<mat-icon class="filter-icon" [matMenuTriggerFor]="filter"
  >filter_list</mat-icon
>
<mat-menu #filter="matMenu" [hasBackdrop]="false">
  <ng-container *ngIf="!sortDisabled">
    <button mat-menu-item (click)="sort(false)">
      {{ 'common.bukTicketListComponent.titles.ASC' | translate }}
    </button>
    <button mat-menu-item (click)="sort(true)">
      {{ 'common.bukTicketListComponent.titles.DESC' | translate }}
    </button>
    <app-hr class="hr"></app-hr>
  </ng-container>
  <button
    mat-menu-item
    class="filter-menu"
    (click)="$event.stopPropagation()"
    [disableRipple]="true"
  >
    <div>
      {{ 'common.bukTicketListComponent.titles.filterByValue' | translate }}
    </div>
    <div class="all-menu">
      <span (click)="setAllCheckboxes(true)">{{
        'common.bukTicketListComponent.actions.selectAll' | translate
      }}</span>
      <span (click)="setAllCheckboxes(false)">{{
        'common.bukTicketListComponent.actions.deselectAll' | translate
      }}</span>
    </div>
    <mat-form-field appearance="outline">
      <input
        matInput
        placeholder="{{
          'common.bukTicketListComponent.placeholder.search' | translate
        }}"
        [(ngModel)]="keyword"
      />
      <mat-icon matSuffix *ngIf="!keyword">search</mat-icon>
      <mat-icon matSuffix *ngIf="keyword" (click)="keyword = null"
        >close</mat-icon
      >
    </mat-form-field>
    <cdk-virtual-scroll-viewport
      itemSize="50"
      class="items"
      [class.empty]="_items?.length === 0"
    >
      <mat-checkbox
        *cdkVirtualFor="let item of _items | searchFilter: keyword:'title'"
        color="primary"
        class="item"
        [checked]="item.checked"
        (change)="checkChanged($event.checked, item.index)"
        >{{ item.title }}</mat-checkbox
      >
    </cdk-virtual-scroll-viewport>
  </button>
  <button mat-menu-item class="buttons">
    <button mat-stroked-button (click)="cancel()">
      {{ 'common.actions.cancel' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      [disabled]="isDisabledFilteringButton"
      (click)="ok()"
    >
      {{ 'common.actions.ok' | translate }}
    </button>
  </button>
</mat-menu>
